import util from './util'

const routes = util.isInMpSdtj ? [

] : []

export default routes
